import React from "react";
import "./styles.scss";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Button, ButtonSize } from "@trussle/external-components";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import { IContentfulRichTextResponse } from "../../types/IContentfulRichText";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export type BlockCardProps = {
  image: IContentfulImage & ImageDataLike;
  title: string;
  content: IContentfulRichTextResponse;
  buttonText: string;
  onClick: () => void;
};

const BlockCard: React.FC<BlockCardProps> = ({
  image,
  title,
  content,
  buttonText,
  onClick,
}) => (
  <div className="block-card">
    <GatsbyImageOrSvg image={image} loading="lazy" alt={title} className="block-card-image" />
    <h2 className="block-card-title">{title}</h2>
    <div className="block-card-content">{renderRichText(content)}</div>
    <Button
      className="block-card-cta"
      size={ButtonSize.Medium}
      onClick={onClick}
    >
      {buttonText}
    </Button>
  </div>
);

export default BlockCard;
